export enum SetStatus {
  planned = 0,
  current = 1,
  completed = 2,
  none = -1
}
